import { cexBotStatesQueryKey } from '@/shared/consts/query-keys';

import { ECexName } from 'web3';

export const CEX_QUERY_KEYS = {
  all: ['cex'] as const,
  botStates: cexBotStatesQueryKey,
  capabilities: (exchange?: ECexName) =>
    [...CEX_QUERY_KEYS.all, 'capabilities', exchange ?? 'unknown'] as const,
  symbolStatuses: (keys: string[]) => [...CEX_QUERY_KEYS.all, 'symbol-statuses', ...keys] as const,
} as const;

export const CEX_MUTATION_KEYS = {
  botStates: ['cex-bot-states'] as const,
} as const;
